// extracted by mini-css-extract-plugin
export default {"icon":"ScnJPVQE","wrapper":"wyg4yuVA","submit":"mdeZWNKi","button":"tlYBwHMJ","label":"E1xFha0n"};